import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";

const EngagementActivitiesSection = () => {
  const activities = [
    {
      icon: "fa fa-coffee",
      title: '"Tea with Jagmohan Singh" – Lucky Draw',
      description: "Completely FREE participation. Selected participants get exclusive one-to-one time. Creates excitement and premium networking value.",
      iconColor: "#252686",
    },
    {
      icon: "fa fa-comments-o",
      title: "Live Polling & Interactive Sessions",
      description: "Tools like Slido (free version) used during sessions. Real-time audience participation. High engagement & live feedback.",
      iconColor: "#F2BC00",
    },
  ];

  return (
    <section className="section-padding" style={{ background: "#f8f9fa" }}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <SectionTitle
              title="Special Engagement Activities"
              titleStyle={{ color: "#252686" }}
              paragarap=""
            />
          </div>
        </div>
        <div className="row">
          {activities.map((activity, idx) => (
            <div key={idx} className="col-lg-6 col-md-6 col-12" style={{ marginBottom: "30px" }}>
              <div
                className="services-card engagement-card"
                style={{
                  background: "#fff",
                  borderRadius: "15px",
                  padding: "40px",
                  height: "100%",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow = "0px 8px 25px rgba(0, 0, 0, 0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.1)";
                }}
              >
                <div style={{ textAlign: "center", marginBottom: "25px" }}>
                  <div style={{ width: "70px", height: "70px", borderRadius: "15px", background: activity.iconColor, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
                    <i className={activity.icon} style={{ fontSize: "36px", color: "#fff" }}></i>
                  </div>
                  <h3 style={{ margin: 0, fontSize: "22px", fontWeight: "bold", lineHeight: "1.4", color: "#333" }}>
                    {activity.title}
                  </h3>
                </div>
                <p style={{ fontSize: "16px", lineHeight: "1.7", textAlign: "center", margin: 0, color: "#525252" }}>
                  {activity.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EngagementActivitiesSection;

